// 网黑料 · 聚合门户首页 mock 数据（静态展示用）
// 内容仅作题材索引与栏目示例，不含对特定真实个体的指控性描述。

export const hotWords = [
  { text: "带货翻车", heat: 98 },
  { text: "流量主播", heat: 96 },
  { text: "品牌联名", heat: 92 },
  { text: "饭圈应援", heat: 89 },
  { text: "合同纠纷", heat: 86 },
  { text: "虚假宣传", heat: 84 },
  { text: "数据注水", heat: 81 },
  { text: "私域运营", heat: 78 },
  { text: "明星塌房", heat: 75 },
  { text: "直播售假", heat: 73 },
  { text: "跨平台搬运", heat: 70 },
  { text: "借势营销", heat: 66 },
];

export const indexRank = [
  { text: "头部主播直播售假调查", tag: "监督", heat: 972 },
  { text: "品牌联名营销翻车复盘", tag: "复盘", heat: 916 },
  { text: "饭圈应援与打投乱象", tag: "现象", heat: 861 },
  { text: "网红直播间数据注水全貌", tag: "深挖", heat: 808 },
  { text: "合同违约与翻脸纠纷合集", tag: "合同", heat: 743 },
  { text: "虚假宣传处罚案例盘点", tag: "法务", heat: 691 },
  { text: "私域割韭菜套路拆解", tag: "警示", heat: 640 },
  { text: "跨平台搬运与二创边界", tag: "版权", heat: 587 },
  { text: "借势营销翻车现场集锦", tag: "热点", heat: 531 },
  { text: "明星代言风控与塌房预警", tag: "风控", heat: 478 },
];

export type TopicItem = {
  id: number;
  kind: string;
  title: string;
  summary: string;
  source: string;
  tag: string;
  reads: string;
  cover: string;
  wide: boolean;
};

export const topics: TopicItem[] = [
  {
    id: 1,
    kind: "专题合集",
    title: "直播间售假调查档案",
    summary: "从选品、话术到售后取证，梳理直播带货售假链条中的常见问题与典型纠错路径。",
    source: "内容查询 · 消费监督",
    tag: "深挖",
    reads: "18.6万次阅读",
    cover: "https://readdy.ai/api/search-image?query=editorial%20investigation%20folder%20with%20red%20evidence%20tape%20and%20magnifying%20glass%20on%20dark%20desk%2C%20dramatic%20moody%20lighting%2C%20documentation%20and%20receipts%20scattered%2C%20journalistic%20style%20still%20life%2C%20crimson%20accents%2C%20high%20detail&width=1200&height=760&seq=topic-wide-01&orientation=landscape",
    wide: true,
  },
  {
    id: 2,
    kind: "时效专题",
    title: "联名营销翻车周报",
    summary: "品牌跨界联名的集中翻车盘点，拆解营销声明与用户情绪之间的落差。",
    source: "热点跟进",
    tag: "营销",
    reads: "9.4万次阅读",
    cover: "https://readdy.ai/api/search-image?query=contemporary%20consumer%20advertisement%20collage%20with%20overlapping%20brand%20logos%20and%20broken%20badge%20symbols%2C%20warm%20paper%20tones%20with%20crimson%20mark%20overlay%2C%20flat%20editorial%20style%2C%20clean%20composition&width=600&height=600&seq=topic-small-02&orientation=squarish",
    wide: false,
  },
  {
    id: 3,
    kind: "人物专题",
    title: "顶流主播争议时间线",
    summary: "按时间轴回放流量主播从爆红到争议的节点事件，理清传闻与辟谣的分界。",
    source: "人物检索",
    tag: "时间线",
    reads: "12.1万次阅读",
    cover: "https://readdy.ai/api/search-image?query=modern%20studio%20backdrop%20with%20spotlight%20stage%20and%20social%20media%20profile%20cards%20in%20shadow%2C%20editorial%20concept%20of%20public%20scrutiny%2C%20warm%20amber%20and%20ink%20tones%2C%20moody%20dramatic%20light&width=600&height=600&seq=topic-small-03&orientation=squarish",
    wide: false,
  },
  {
    id: 4,
    kind: "行业深挖",
    title: "数据注水产业链拆解",
    summary: "刷量、买水军与虚假热度背后的产业链结构，教你看穿热度数据里的水分。",
    source: "行业报告",
    tag: "深挖",
    reads: "7.8万次阅读",
    cover: "https://readdy.ai/api/search-image?query=abstract%20network%20of%20nodes%20and%20fake%20bot%20accounts%20rising%20chart%2C%20conceptual%20data%20illustration%2C%20charcoal%20and%20warm%20bronze%20palette%2C%20minimal%20editorial%20graphic%20style&width=600&height=600&seq=topic-small-04&orientation=squarish",
    wide: false,
  },
  {
    id: 5,
    kind: "饭圈现象",
    title: "应援打投乱象观察",
    summary: "从集资应援到打榜控评，梳理饭圈应援链条中的资金与秩序问题。",
    source: "内容查询 · 娱乐",
    tag: "观察",
    reads: "6.2万次阅读",
    cover: "https://readdy.ai/api/search-image?query=concert%20light%20sticks%20and%20fan%20posters%20in%20a%20dim%20hall%2C%20editorial%20reportage%20mood%2C%20warm%20stage%20lighting%20with%20shadow%2C%20crowd%20energy%2C%20documentary%20style&width=600&height=600&seq=topic-small-05&orientation=squarish",
    wide: false,
  },
  {
    id: 6,
    kind: "法务档案",
    title: "违约与代言纠纷档案",
    summary: "合同细节、违约责任与代言翻脸案例汇总，提供关键词导向的内容查询入口。",
    source: "法务专题",
    tag: "合同",
    reads: "5.5万次阅读",
    cover: "https://readdy.ai/api/search-image?query=legal%20documents%20and%20contract%20pages%20with%20signature%20seal%20stamp%2C%20judicial%20gavel%20and%20lens%2C%20warm%20desk%20light%2C%20editorial%20corporate%20reportage%2C%20amber%20and%20ink%20tones%2C%20sharp%20detail&width=1200&height=760&seq=topic-wide-06&orientation=landscape",
    wide: true,
  },
  {
    id: 7,
    kind: "消费警示",
    title: "虚假宣传案例清单",
    summary: "常见功效夸大与虚假宣称案例，帮你在选购与跟风前先做一次内容查询。",
    source: "消费监督",
    tag: "警示",
    reads: "4.3万次阅读",
    cover: "https://readdy.ai/api/search-image?query=product%20boxes%20with%20misleading%20claims%20tagged%20with%20red%20warning%20labels%20on%20clean%20shelf%2C%20consumer%20report%20concept%2C%20warm%20neutral%20background%2C%20flat%20editorial%20photography&width=600&height=600&seq=topic-small-07&orientation=squarish",
    wide: false,
  },
  {
    id: 8,
    kind: "社群观察",
    title: "私域运营套路拆解",
    summary: "从拉群话术到限时逼单，逐一拆解私域运营中的常见套路与边界。",
    source: "行业观察",
    tag: "警示",
    reads: "3.9万次阅读",
    cover: "https://readdy.ai/api/search-image?query=messaging%20chat%20bubbles%20and%20group%20notifications%20floating%20over%20a%20phone%20screen%2C%20editorial%20concept%20of%20online%20community%20sales%20tactics%2C%20charcoal%20and%20amber%20tones%2C%20clean%20minimal%20graphic&width=600&height=600&seq=topic-small-08&orientation=squarish",
    wide: false,
  },
  {
    id: 9,
    kind: "版权专栏",
    title: "搬运二创边界盘点",
    summary: "内容搬运、二次创作与跨平台转载的版权边界，为创作者提供检索参考。",
    source: "内容专题",
    tag: "版权",
    reads: "3.1万次阅读",
    cover: "https://readdy.ai/api/search-image?query=copyright%20symbol%20and%20clapperboard%20with%20duplicated%20film%20strips%2C%20editorial%20media%20concept%2C%20warm%20paper%20background%20with%20ink%20details%2C%20minimal%20flat%20design&width=600&height=600&seq=topic-small-09&orientation=squarish",
    wide: false,
  },
];

export const channels = [
  { no: "01", name: "娱乐星闻", desc: "艺人动态与争议热度的关键词检索分区。", chips: ["塌房", "翻车", "争议", "时间线"], reads: "关注 82 万" },
  { no: "02", name: "商业财经", desc: "企业、品牌与资本动向的专题与内容查询入口。", chips: ["联名", "违约", "舆情", "财报"], reads: "关注 61 万" },
  { no: "03", name: "主播网红", desc: "直播带货与网红生态的话题聚合与内容索引。", chips: ["售假", "刷量", "人设", "售后"], reads: "关注 75 万" },
  { no: "04", name: "饭圈文化", desc: "应援、打榜与粉丝圈层现象的观察专区。", chips: ["集资", "打投", "控评", "对立"], reads: "关注 48 万" },
  { no: "05", name: "品牌消费", desc: "消费陷阱、虚假宣传与跟风避坑的内容查询区。", chips: ["夸大", "踩雷", "维权", "清单"], reads: "关注 54 万" },
  { no: "06", name: "平台规则", desc: "内容搬运、二创与社区规则的边界检索。", chips: ["版权", "限流", "搬运", "封禁"], reads: "关注 37 万" },
];

export const timeline = [
  { title: "头部主播售假调查档案新增三份取证材料", zone: "主播网红", time: "12 分钟前", flag: "更新" },
  { title: "品牌联名翻车周报本周收录 7 起案例", zone: "商业财经", time: "46 分钟前", flag: "周报" },
  { title: "应援打投乱象观察专题补全资金流向节点", zone: "饭圈文化", time: "1 小时前", flag: "补全" },
  { title: "虚假宣传案例清单按品类重新归档", zone: "品牌消费", time: "3 小时前", flag: "归档" },
  { title: "私域运营套路拆解新增话术比对样本", zone: "行业观察", time: "5 小时前", flag: "上新" },
  { title: "搬运二创边界盘点同步最新平台规则条款", zone: "平台规则", time: "昨日", flag: "同步" },
];